import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Categories16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.88381 1.82321C8.39565 1.33505 7.6042 1.33505 7.11604 1.82321L4.82315 4.1161C4.33499 4.60426 4.33499 5.39571 4.82315 5.88387L7.11604 8.17676C7.6042 8.66492 8.39565 8.66492 8.88381 8.17676L11.1767 5.88387C11.6649 5.39571 11.6649 4.60426 11.1767 4.1161L8.88381 1.82321ZM6.06058 4.99999L7.99992 3.06065L9.93926 4.99999L7.99992 6.93933L6.06058 4.99999Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.75 11.5C0.75 9.70507 2.20507 8.25 4 8.25C5.79493 8.25 7.25 9.70507 7.25 11.5C7.25 13.2949 5.79493 14.75 4 14.75C2.20507 14.75 0.75 13.2949 0.75 11.5ZM4 9.75C3.0335 9.75 2.25 10.5335 2.25 11.5C2.25 12.4665 3.0335 13.25 4 13.25C4.9665 13.25 5.75 12.4665 5.75 11.5C5.75 10.5335 4.9665 9.75 4 9.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.6431 8.61413L15.6431 13.6141C15.9375 14.1048 15.5722 14.75 15 14.75H9C8.42783 14.75 8.0625 14.1048 8.35688 13.6141L11.3569 8.61413C11.6429 8.13738 12.3571 8.13738 12.6431 8.61413ZM13.6754 13.25L12 10.4577L10.3246 13.25H13.6754Z'
      fill='currentColor'
    />
  </Svg>
);

Categories16.displayName = 'Categories16';
export default Categories16;
